import 'reflect-metadata'
import { injectable } from 'inversify-props'
import { AtributoServiceAdapter } from '@/usecases'
import { getAtributo, findAtributo, createAtributo } from '@/api/produtos'
import { AxiosRequestConfig } from 'axios'
import { Atributo } from '@/models/@types/Atributo'

@injectable()
export class AtributoService implements AtributoServiceAdapter {
	get = async (id: string) => await getAtributo(id)
	find = async (params?: any, config?: AxiosRequestConfig) => await findAtributo(params, config)
	create = async (atributo: Atributo) => await createAtributo(atributo)
}
